
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import api from '../../services/api';
import './Dashboard.css';

const ShopAdminDashboard = () => {
  const [stats, setStats] = useState({
    activeAds: 0,
    expiredAds: 0,
    subscription: null,
    profile: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [adsRes, subscriptionRes, profileRes] = await Promise.all([
        api.get('/api/shop/ads?limit=1'),
        api.get('/api/shop/subscription').catch(() => ({ data: { success: false } })),
        api.get('/api/shop/profile').catch(() => ({ data: { success: false } }))
      ]);

      setStats({
        activeAds: adsRes.data.pagination?.total || 0,
        expiredAds: 0,
        subscription: subscriptionRes.data.success ? subscriptionRes.data.data : null,
        profile: profileRes.data.success ? profileRes.data.data : null
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar />
        <div className="loading"><div className="spinner"></div></div>
      </div>
    );
  }

  return (
    <div className="app">
      <Navbar />
      <div className="container">
        <div className="dashboard-header-modern">
          <div>
            <h1 className="page-title">Shop Dashboard</h1>
            <p className="page-subtitle">Welcome back! Here's your shop overview</p>
          </div>
          <Link to="/shop/profile" className="btn btn-outline">
            Edit Profile
          </Link>
        </div>

        {stats.profile && (
          <div className="shop-info-card">
            <div className="shop-info-header">
              {stats.profile.logoUrl && (
                <img src={stats.profile.logoUrl} alt={stats.profile.name} className="shop-logo-large" />
              )}
              <div className="shop-info-details">
                <h2>{stats.profile.name}</h2>
                <div className="shop-meta">
                  <span className="shop-meta-item">📍 {stats.profile.district}, {stats.profile.state}</span>
                  {stats.profile.websiteUrl && (
                    <a href={stats.profile.websiteUrl} target="_blank" rel="noopener noreferrer" className="shop-meta-item">
                      🌐 Website
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="stats-grid-modern">
          <div className="stat-card-modern stat-primary">
            <div className="stat-icon">📢</div>
            <div className="stat-info">
              <h3>Active Ads</h3>
              <div className="stat-value-large">{stats.activeAds}</div>
              <Link to="/shop/ads" className="stat-link">View all ads →</Link>
            </div>
          </div>
          
          {stats.subscription ? (
            <>
              <div className="stat-card-modern stat-success">
                <div className="stat-icon">💎</div>
                <div className="stat-info">
                  <h3>Current Plan</h3>
                  <div className="stat-value-medium">{stats.subscription.planId?.name || 'No Plan'}</div>
                  <div className="stat-details">
                    <div className="stat-detail-item">
                      <span>Max Ads:</span>
                      <strong>{stats.subscription.planId?.maxMainAds || 0}</strong>
                    </div>
                    <div className="stat-detail-item">
                      <span>Remaining:</span>
                      <strong>{stats.subscription.remainingMainAdsCount || 0}</strong>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="stat-card-modern stat-info">
                <div className="stat-icon">📊</div>
                <div className="stat-info">
                  <h3>Subscription Status</h3>
                  <div className="stat-value-medium">Active</div>
                  <p className="stat-subtext">
                    Expires: {stats.subscription.endDate 
                      ? new Date(stats.subscription.endDate).toLocaleDateString() 
                      : 'N/A'}
                  </p>
                </div>
              </div>
            </>
          ) : (
            <div className="stat-card-modern stat-warning">
              <div className="stat-icon">⚠️</div>
              <div className="stat-info">
                <h3>No Active Subscription</h3>
                <p className="stat-subtext">Subscribe to a plan to start creating ads</p>
                <Link to="/shop/plans" className="btn btn-primary btn-sm" style={{ marginTop: '10px' }}>
                  View Plans
                </Link>
              </div>
            </div>
          )}

          <div className="stat-card-modern stat-secondary">
            <div className="stat-icon">📈</div>
            <div className="stat-info">
              <h3>Quick Actions</h3>
              <div className="quick-actions">
                <Link to="/shop/ads" className="quick-action-btn">Create Ad</Link>
                <Link to="/shop/profile" className="quick-action-btn">Edit Profile</Link>
              </div>
            </div>
          </div>
        </div>

        {stats.subscription && (
          <div className="action-card">
            <div className="action-card-content">
              <div>
                <h3>Ready to create ads?</h3>
                <p>Start promoting your products and services to reach more customers</p>
              </div>
              <Link to="/shop/ads" className="btn btn-primary btn-large">
                Create New Ad
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopAdminDashboard;

